// What a tab shares with the other tabs of the same browser through localStorage ("store"): its token, and whether the
// person logged out. Only the person's own logout travels to the other tabs: a tab that is thrown out because its token
// is no longer valid must not log out the tabs that hold a good one (a new login in one tab, a stale page in another).

export const LOGOUT_BY_USER = "user";
// this tab follows the logout of another tab
export const LOGOUT_FOLLOWING = "following";
// the server refused the token of this tab
export const LOGOUT_EXPIRED = "expired";

/** The reason and the refused token of a logout: a string is a reason, an object carries the token that failed. */
export function logoutOf(payload) {
  if (typeof payload === "string") {
    return { reason: payload, token: null };
  }
  return {
    reason: payload?.reason ?? LOGOUT_EXPIRED,
    token: payload?.token ?? null,
  };
}

/**
 * Whether the tab writes its logged out state into the shared entry. A refused token clears the shared one only when
 * it is that token (or there is none): a different shared token is a newer login of another tab.
 */
export function sharesLogout(logout, shared) {
  if (logout.reason === LOGOUT_FOLLOWING) {
    return false;
  }
  if (logout.reason === LOGOUT_BY_USER) {
    return true;
  }
  return !shared?.token || shared.token === logout.token;
}

/** The shared entry, as a tab writes it. */
export function sharedState(state) {
  return {
    logged: state.logged,
    showRightMenu: state.showRightMenu,
    token: state.token,
    loggedOutByUser: state.logoutReason === LOGOUT_BY_USER,
  };
}

/** Whether the entry written by another tab logs this tab out: only the person's own logout does. */
export function followsLogout(shared, tabLogged) {
  return Boolean(
    tabLogged && !shared?.token && shared?.loggedOutByUser === true
  );
}
